import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service";
import { IComponentController } from "angular";

interface IPageMr2024 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireSid: IFormulaire;
    sic1MultiOccurrenceOptions: IMultiOccurrenceOptions;
    sic2MultiOccurrenceOptions: IMultiOccurrenceOptions;
    sic3MultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr2024Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageMr2024 = this;
    vm.formulaireSid = new Formulaire('LBL_BLC_SID', [
        new FormulaireItem('ecrcleint'),
        new FormulaireItem('sidinddem')
    ], { largeurDefaut: 25 });

    vm.sic1MultiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'sicseqaff', largeur: 150 },
            { nom: 'sisdsc', largeur: 250 },
            { nom: 'sicdscnul', largeur: 250 },
            { nom: 'siddsc', largeur: 250 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('sicseqaff', { largeur: 33 }),
            new FormulaireItem('siscleint', {
                resourceParams: (data: any) => ({ sidcleint: data.$ancetre.sidcleint }),
                largeur: 33
            }),
            new FormulaireItem('sicdscnul', { largeur: 33 })
        ], { largeurDefaut: 35 })
    };

    vm.sic2MultiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'sicseqaff', largeur: 170 },
            { nom: 'sisdsc', largeur: 250 },
            { nom: 'sicdscnul', largeur: 250 },
            { nom: 'siddsc', largeur: 250 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('sicseqaff', { largeur: 33 }),
            new FormulaireItem('siscleint', {
                resourceParams: (data: any) => ({ sidcleint: data.$ancetre.sidcleint }),
                largeur: 33
            }),
            new FormulaireItem('sicdscnul', { largeur: 33 })
        ], { largeurDefaut: 35 })
    };

    vm.sic3MultiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'sicseqaff', largeur: 170 },
            { nom: 'sisdsc', largeur: 250 },
            { nom: 'sicdscnul', largeur: 250 },
            { nom: 'siddsc', largeur: 250 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('sicseqaff', { largeur: 33 }),
            new FormulaireItem('siscleint', {
                resourceParams: (data: any) => ({ sidcleint: data.$ancetre.sidcleint }),
                largeur: 33
            }),
            new FormulaireItem('sicdscnul', { largeur: 33 })
        ], { largeurDefaut: 35 })
    };
}
